module.exports = "<svg id=\"__1Dm1det__dd6d3b5d-736e-4112-a978-d559f0ef793b\" data-name=\"70f8052d-3d8c-41fb-92d4-1085a59c667f\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35.39 3.6\"><title>donauhof-seperator</title><path d=\"M.35,1.9a3.73,3.73,0,0,0,2.7,1.2c3.5,0,2.3-2.6,5.8-2.6,2.9,0,3.1,2.6,5.8,2.6,3,0,2.6-2.6,5.7-2.6,2.8,0,3.3,2.6,5.8,2.6,3,0,2.8-2.6,5.8-2.6a4.37,4.37,0,0,1,3.1,1.4\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/donauhof-seperator.svg
// module id = 112
// module chunks = 1